export default __webpack_public_path__ + "static/media/status-green.516a162c.png";